import React, { useState, useRef, useEffect } from "react";
import TwInputText from "./input.text";
import TwCheck from "./input.check";
import { useComponentVisible } from "../tools/ComponentVisible";

const TwInputSelect = ({ value, options, label, onChange, onKeyDown, defaultValue, size, placeholder, inputProps, multiSelect, direction }) => {
    const {ref, isOpen, setIsOpen} = useComponentVisible(false);
    const [inputValue, setInputValue] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [selectedTitle, setSelectedTitle] = useState("-");
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    const handleOptionToggle = (newValue) => {
        const updatedOptions = multiSelect ? (value.includes(newValue) ? value.filter((option) => option !== newValue) : [...value, newValue]) : newValue
        onChange(updatedOptions);
        !multiSelect && setIsOpen(false)
    };

    const getDropdownTitle = () => {
        const selectedItems = multiSelect ? value : [value];
        if (selectedItems.length === 0) return "انتخاب نشده";
        if (selectedItems.length === 1) return options.find((opt) => opt.id === selectedItems[0])?.title ?? "انتخاب نشده";
        return selectedItems.map((item) => options.find((opt) => opt.id === item)?.title).join("، ") ?? "انتخاب نشده";
        // return `${selectedItems.length} گزینه انتخاب شده`;
    };
    useEffect(() => {
        setSelectedTitle(getDropdownTitle());
    }, [value, options]);
    useEffect(() => {
        setFilteredOptions(options.filter((option) => option.title?.toLowerCase().includes(inputValue.toLowerCase())).slice(0, 100));
        if (isOpen) {
            setTimeout(() => inputRef.current?.focus(), 10);
        }
    }, [inputValue, options]);

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => <>{children}</>);

    const inputChange = (e) => {
        setInputValue(e.target.value);
    };

    const onToggle = (isOpen) => {
        setIsOpen(isOpen);
    };

    const toggleDropdown = () => setIsOpen(!isOpen);

    const cssClass = ["relative"];
    if (direction != "ltr") {
        cssClass.push("rtl");
    }
    const btnClasses = [
        "flex",
        "gap-x-1.5",
        "shadow",
        "appearance-none",
        "border",
        "rounded",
        "w-full",
        "py-1",
        "px-2",
        "text-gray-700",
        "dark:text-gray-300",
        "leading-tight",
        "focus:outline-none",
        "focus:shadow-outline",
        "bg-transparent",
        "items-center",
        "justify-start",
        "whitespace-nowrap",
        "overflow-hidden",
        "dark:text-gray-200",
        // "gap-x-1.5",
        // "rounded-md",
        // "bg-white",
        // "px-2",
        // "py-1",
        // "text-sm",
        // "text-gray-900",
        // "shadow-sm",
        // "ring-1",
        // "ring-inset",
        // "ring-gray-300",
        // "hover:bg-gray-50"
    ]
    return (
        <div className={cssClass.join(" ")}>
            {/* <label className="block text-gray-500 text-sm text-sm mb-2">
                {label}
            </label> */}
            <button
                onClick={toggleDropdown}
                type="button"
                className={btnClasses.join(" ")}
                id="menu-button"
                aria-expanded="true"
                aria-haspopup="true"
            >
                <div className="grow text-start">{selectedTitle}</div>
                <i className="multi-dropdown-arrow fal fa-chevron-down"></i>
            </button>

            <div ref={ref}>
                {isOpen && <div
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white dark:bg-gray-700 dark:text-gray-200 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                    tabIndex="-1"
                >
                    <div className="p-2 border-b border-gray-500">
                        <TwInputText onChange={inputChange} />
                    </div>
                    <div className="py-1 max-h-96 overflow-auto" role="none">
                        {filteredOptions.map((option) => (
                            <div
                                key={option.id}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOptionToggle(option.id);
                                }}
                                className="block px-2 py-1 text-sm cursor-pointer border-b border-gray-500"
                                role="menuitem"
                                tabIndex="-1"
                                id="menu-item-0"
                            >
                                {multiSelect && <TwCheck type="checkbox" label={option.title} checked={(multiSelect && value.includes(option.id)) || (!multiSelect && value == option.id)} onChange={() => {}} />}
                                {!multiSelect && <span>{option.title}</span>}
                            </div>
                        ))}
                    </div>
                </div>}
            </div>
        </div>
    );
};


export default TwInputSelect;
